import { FC, ReactNode } from 'react';
import { Helmet } from '@edikk-edikk/helmet';
import { usePageContext } from '#page/hooks';

const MetaData: FC = () => {
  const { page } = usePageContext();

  const renderMetaTitle = (): ReactNode => {
    if (!page.metaTitle) {
      return null;
    }

    return (
      <Helmet>
        <title>
          {page.metaTitle}
        </title>
      </Helmet>

    );
  };

  const renderMetaDescription = (): ReactNode => {
    if (!page.metaDescription) {
      return null;
    }

    return (
      <Helmet>
        <meta name="description" content={page.metaDescription} />
      </Helmet>

    );
  };

  return (
    <>
      {renderMetaTitle()}
      {renderMetaDescription()}
    </>
  );
};

export { MetaData };
